/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Badge_PassiveInputs */

const tr_landing_pricerules_mock_badge_passive = /** @type {(inputs: Landing_Pricerules_Mock_Badge_PassiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pasif`)
};

const en_landing_pricerules_mock_badge_passive = /** @type {(inputs: Landing_Pricerules_Mock_Badge_PassiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inactive`)
};

const de_landing_pricerules_mock_badge_passive = /** @type {(inputs: Landing_Pricerules_Mock_Badge_PassiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inaktiv`)
};

const ru_landing_pricerules_mock_badge_passive = /** @type {(inputs: Landing_Pricerules_Mock_Badge_PassiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`неактивно`)
};

/**
* | output |
* | --- |
* | "inactive" |
*
* @param {Landing_Pricerules_Mock_Badge_PassiveInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_badge_passive = /** @type {((inputs?: Landing_Pricerules_Mock_Badge_PassiveInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Badge_PassiveInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_badge_passive(inputs)
	if (locale === "de") return de_landing_pricerules_mock_badge_passive(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_badge_passive(inputs)
	return tr_landing_pricerules_mock_badge_passive(inputs)
});